module.exports = __webpack_public_path__ + "static/media/tradeMonitor.d5534f60.png";